import { Box, IconButton, useTheme, Typography, useMediaQuery } from "@mui/material";
import { useContext, useState } from "react";
import { ColorModeContext } from "../theme";
import logo from "../assets/logo.png";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../features/authSlice";
import CustomDialog from "./cutomPopUp";
import { useRestaurant } from "../hooks/RestaurantContext";
import LanguageSwitcher from "./LanguageSwitcher";
import { useTranslation } from "react-i18next";

const name = process.env.REACT_APP_NAME;

const RestaurantTopBar = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isCompact = useMediaQuery("(max-width:900px)");
  const colorMode = useContext(ColorModeContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setRestaurantId, setRestaurantName, setRestaurantLogo, setCurrency } =
    useRestaurant();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    setRestaurantId("");
    setRestaurantName("");
    setRestaurantLogo("");
    setCurrency("");
    navigate("/signin");
  };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      className="topbar"
    >
      <Box display="flex" alignItems="center" gap={1} minWidth={0} flex={1}>
        <Box
          sx={{
            height: isCompact ? 40 : 52,
            width: isCompact ? 40 : 52,
            borderRadius: 2,
            overflow: "hidden",
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={logo}
            alt=""
            style={{
              height: "190%",
              width: "190%",
              objectFit: "cover",
              objectPosition: "center 38%",
            }}
          />
        </Box>
        <Typography
          variant={isCompact ? "h5" : "h2"}
          fontWeight={800}
          color="inherit"
          noWrap
          sx={{ overflow: "hidden", textOverflow: "ellipsis" }}
        >
          {name}
        </Typography>
      </Box>
      <Box alignItems="center" display="flex" gap={0.25} flexShrink={0}>
        <LanguageSwitcher />
        <IconButton onClick={colorMode.toggleColorMode} size={isCompact ? "small" : "medium"}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
        {isCompact ? (
          <IconButton
            onClick={() => setIsOpen(true)}
            aria-label={t("auth.logout")}
            size="small"
            sx={{
              ml: 1.5,
              bgcolor: "error.main",
              color: "#fff",
              opacity: 0.9,
              "&:hover": { bgcolor: "error.dark", opacity: 1 },
            }}
          >
            <LogoutIcon fontSize="small" />
          </IconButton>
        ) : (
          <Box
            onClick={() => setIsOpen(true)}
            role="button"
            aria-label={t("auth.logout")}
            sx={{
              ml: 2.5,
              display: "flex",
              alignItems: "center",
              gap: 0.75,
              px: 1.5,
              py: 0.75,
              borderRadius: "8px",
              cursor: "pointer",
              color: "error.main",
              bgcolor: (theme) =>
                theme.palette.mode === "dark"
                  ? "rgba(233,49,60,0.14)"
                  : "rgba(233,49,60,0.08)",
              "&:hover": {
                bgcolor: (theme) =>
                  theme.palette.mode === "dark"
                    ? "rgba(233,49,60,0.22)"
                    : "rgba(233,49,60,0.14)",
              },
            }}
          >
            <LogoutIcon fontSize="small" />
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              {t("auth.logout")}
            </Typography>
          </Box>
        )}
      </Box>
      <CustomDialog
        open={isOpen}
        handleClose={() => setIsOpen(false)}
        title={t("auth.logoutTitle")}
        message={t("auth.logoutConfirm")}
        cancelText={t("common.cancel")}
        confirmText={t("auth.logout")}
        onClick={handleLogout}
      />
    </Box>
  );
};

export default RestaurantTopBar;
